export default "__VITE_ASSET__C4k3o39Q__"